import React from "react";
import TwoFactorPanel from "@/components/TwoFactorPanel";

export default function Security() {
  return (
    <div className="space-y-6 max-w-2xl" data-testid="security-page">
      <div>
        <h1 className="font-heading text-3xl tracking-tight">Keamanan Akun</h1>
        <p className="mt-1 text-sm text-muted-foreground">Kelola autentikasi dua faktor (2FA) untuk akun Anda.</p>
      </div>
      <TwoFactorPanel />
    </div>
  );
}
